import Store from '@/store/main.js';

Store.watch(
	() => Store.state.request.main.agrSelected,
	() => {
		Store.dispatch('request/main/loadAgrData');
	}
);
